// Payment configuration constants

import { PROCESSOR_NAMES } from 'utils/constants';
import { isProcessorType } from 'utils/processor';

/**
 * Processors whose global defaults can be overridden per individual terminal —
 * so the "These defaults can be overridden for individual terminals under
 * Payment device configurations." notice is relevant on their Global
 * configuration screen.
 *
 * Currently Vector only. It was previously the case for old Paybotic, and will
 * apply again if we integrate Salt — add the processor name here when that
 * happens. Processors without terminals (e.g. Boomerang) must NOT be listed.
 *
 * Values match the backend `processorName` (see IProcessors.processorName).
 */
export const PROCESSORS_WITH_TERMINAL_OVERRIDE_NOTICE = ['VECTOR'] as const;

/**
 * Whether the per-terminal override notice should be surfaced for the given
 * processor. Case-insensitive so it is resilient to backend casing changes.
 */
export const showsTerminalOverrideNotice = (
  processorName: string | undefined | null
): boolean =>
  !!processorName &&
  PROCESSORS_WITH_TERMINAL_OVERRIDE_NOTICE.some(
    (name) => name.toLowerCase() === processorName.toLowerCase()
  );

// Not Aeropay-specific — PAYOMI and Barterpay ship one too — so the copy below
// is gated on the selected provider, never on this code alone.
export const PROCESSOR_FEE_CONFIG_CODE = 'processorFee';

// Was Pendo-delivered and lost in the refactor; hardcoded so it outlives Pendo.
export const AEROPAY_FEE_TOOLTIP =
  'The fee added here will be applied to Aeropay transactions. This fee will be charged to the customer.';

export const getConfigFieldTooltip = (
  processorName: string | undefined | null,
  code: string | undefined
): string | undefined =>
  code === PROCESSOR_FEE_CONFIG_CODE &&
  isProcessorType(processorName ?? '', PROCESSOR_NAMES.AEROPAY)
    ? AEROPAY_FEE_TOOLTIP
    : undefined;
